const getByPath = (obj: any, path: string): any => {
    return path
        .split(".")
        .reduce(
            (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
            obj
        );
};

const stringifyFilterValue = (value: any) => {
    if (value === undefined || value === null) {
        return "";
    }

    if (typeof value === "string") {
        return value;
    }

    if (value && typeof value === "object" && "id" in value) {
        return String(value.id ?? "");
    }

    return String(value);
};

export const evaluateReferenceFilterTemplate = (
    referenceFilter: string,
    values: Record<string, any>
): Record<string, any> | undefined => {
    if (!referenceFilter) {
        return undefined;
    }

    const resolvedFilter = referenceFilter.replace(
        /\$\{([^}]+)\}/g,
        (_, path: string) => {
            const value = getByPath(values, path);
            return stringifyFilterValue(value);
        }
    );

    return JSON.parse(resolvedFilter);
};
